import { render, staticRenderFns } from "./PollVoteActivityMessage.vue?vue&type=template&id=655ca9f9&scoped=true"
import script from "./PollVoteActivityMessage.vue?vue&type=script&lang=js"
export * from "./PollVoteActivityMessage.vue?vue&type=script&lang=js"
import style0 from "./PollVoteActivityMessage.vue?vue&type=style&index=0&id=655ca9f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ca9f9",
  null
  
)

export default component.exports